import React, { PureComponent } from 'react';
import cn from 'classnames';
import { TabContent, TabPane, NavLink } from 'reactstrap';
import { string, array, number, bool, node, oneOfType, func } from 'prop-types';
import Card from './Card';
import { isNil } from '../../utils/utils';

class CardTabs extends PureComponent {
  static propTypes = {
    activeTab: number,
    title: oneOfType([string, node]).isRequired,
    navItems: array.isRequired,
    panes: array.isRequired,
    loading: bool,
    noPadding: bool,
    onTabChange: func,
  };

  static defaultProps = {
    activeTab: 1,
    title: '',
    navItems: [],
    panes: [],
    loading: false,
  };

  renderControls = () => {
    const { navItems, activeTab, additionalElement } = this.props;

    const controls =
      navItems.length > 0
        ? navItems.map((navItem, index) => (
            <NavLink
              key={navItem}
              className={cn({ active: activeTab === index + 1 })}
              onClick={() => {
                this.toggle(index + 1);
              }}
            >
              {' '}
              {navItem}{' '}
            </NavLink>
          ))
        : [];

    if (additionalElement) controls.unshift(additionalElement);
    return controls;
  };

  toggle = (tab) => {
    const { activeTab, onTabChange } = this.props;
    if (activeTab !== tab) {
      onTabChange && onTabChange(tab);
    }
  };

  render() {
    const {
      children,
      title,
      panes,
      loading,
      noPadding,
      className,
      defaultMessage,
      collapsing,
      localStorageName,
      titleLG,
      activeTab,
    } = this.props;

    return (
      <Card.WithControls
        titleLG={titleLG}
        tabs
        className={className}
        controls={this.renderControls()}
        title={title}
        defaultMessage={defaultMessage}
        loading={loading}
        localStorageName={localStorageName}
        collapsing={collapsing}
      >
        <Card.Body className={cn({ 'no-padding': noPadding })}>
          <TabContent activeTab={activeTab}>
            {panes.length > 0 &&
              panes.map((pane, index) => (
                <TabPane key={index} tabId={index + 1}>
                  {pane}
                </TabPane>
              ))}
          </TabContent>
        </Card.Body>
        {!isNil(children) && children}
      </Card.WithControls>
    );
  }
}

export default CardTabs;
